import React, {PureComponent} from 'react';
import ReactMarkdown from 'react-markdown';
import {Line} from 'rc-progress/lib';

import {BannerAd, ImagePicker} from 'components';
import {GENERIC_UPLOAD_ERROR} from 'constants/images';
import {ImageresizeApi} from 'modules';
import {getUrlImageType, getUploadedImageErrorMessage} from 'utils';

import imageResizeHeader from './image-resize-header.md';
import whatIsImageresize from './what-is-imageresize.md';
import easyImageResize from './easy-image-resize.md';
import onlineImageEditor from './online-image-editor.md';
import compressImages from './compress-images.md';
import imageConverter from './image-converter.md';
import photoEnlarger from './photo-enlarger.md';
import supportedUnitsForResizing from './supported-units-for-resizing.md';

export default class ImageSelect extends PureComponent {

  constructor(props) {
    super(props);

    this.state = {
      interval: false,
      urlValue: '',
      uploadProgress: -1
    };
  }

  setMotion() {
    let $this = this;
    let a = 0;
    var interval = setInterval(() => {
      a += .1;
      $this.setState({ uploadProgress: a });
      if(a >= 1) clearInterval($this.state.interval);
    }, 500);
    this.setState({interval});
  }
  componentWillUnmount() {
    if(this.state.interval) {
      clearInterval(this.state.interval);
      this.setState({interval: false});
    }
  }

  uploadImages = (images) => {
    const {onDone, onErrors} = this.props;

    this.setMotion();
    let $this = this;
    // Trigger the upload
    const upload = ImageresizeApi.postImages(images);

    upload.on('error', (ev) => onErrors([GENERIC_UPLOAD_ERROR]));
    upload.on('progress', ({ percentComplete }) => {
      $this.setState({ uploadProgress: percentComplete })
      clearInterval($this.state.interval);
    });
    upload.on('load', () => {

      if (
        upload.xhr.status !== 200 ||
        !upload.response.results ||
        !upload.response.results.length ||
        upload.response.results.find((result) => result.state === 'error')
      ) {
        return onErrors([GENERIC_UPLOAD_ERROR]);
      }

      clearInterval($this.state.interval);
      $this.setState({ uploadProgress: 1 });
      onDone(upload.response.results.map((result, index) => ({
        ...images[index],
        contentLength: result.contentLength,
        dimensions: result.dimensions,
        imageId: result.imageId,
        preview: ImageresizeApi.getImageUrl(result.imageId),
        type: images[index].uploadType === 'image' ?
          images[index].value.type.replace('image/', '') :
          getUrlImageType(images[index].value),
        name: images[index].uploadType === 'image' ?
          images[index].value.name :
          images[index].value
      })));
    });
  }

  handleDropImages = (acceptedFiles, rejectedFiles) => {
    const {onErrors} = this.props;
    
    // The upload failed, tell our parent
    if(rejectedFiles.length) {  
      if(acceptedFiles.length) {
        return onErrors(rejectedFiles.map(() => 'multipleError'));
      } else {
        return onErrors(rejectedFiles.map(getUploadedImageErrorMessage));
      }
    }

    // Format the files in a way that's useful for the rest of the app and API
    const images = acceptedFiles.map((file) => ({
      uploadType: 'image',
      value: file
    }));

    // Send the successful uploads
    this.uploadImages(images);
  };

  handleChangeUrl = (name, value) => this.setState({
    urlValue: value
  });

  handleSubmitUrl = () => {
    const {onErrors} = this.props;
    const {urlValue} = this.state;

    const name = urlValue.split('/').pop().split('#')[0].split('?')[0];

    const ext = name.split('.')[name.split('.').length - 1];

    if ( ext === 'png' || ext === 'jpg' || ext === 'jpeg') {
      // Send the selected url to the parent
      this.uploadImages([{
        uploadType: 'url',
        value: urlValue
      }]);
    } else if ( ext.toLowerCase() === 'pdf') {
      return onErrors(['Use pdf resizer.']);
    } else {
      return onErrors(['URL you entered is not a valid image. Please enter a URL ending with JPG or PNG extensions.']);
    }
  };

  renderProgressBar() {
    const {uploadProgress} = this.state;

    if (uploadProgress < 0) {
      return null;
    }

    return (
      <Line
        className='progressBar'
        percent={uploadProgress * 100}
        strokeColor='#a3d76d'
        strokeLinecap='square'
        strokeWidth='2'
        trailWidth='0'
      />
    );
  }

  render() {
    return (
      <div className='container'>
        <ReactMarkdown className={'center section'} source={imageResizeHeader} />
        <div className='selection-box'>
          <ImagePicker
            accept='image/*'
            fileType="Image"
            dropImages={this.handleDropImages}
            changeUrl={this.handleChangeUrl}
            submitUrlUpload={this.handleSubmitUrl}
            multiple={false}
          />
          {this.renderProgressBar()}
        </div>
        <BannerAd />
        <div className='content'>
          <ReactMarkdown className='section' source={whatIsImageresize} />
          <div className='twoSections'>
            <ReactMarkdown className='section' source={easyImageResize} />
            <ReactMarkdown className='section' source={onlineImageEditor} />
          </div>
          <div className='twoSections'>
            <ReactMarkdown className='section' source={compressImages} />
            <ReactMarkdown className='section' source={imageConverter} />
          </div>
          <div className='twoSections'>
            <ReactMarkdown className='section' source={photoEnlarger} />
            <ReactMarkdown className='section' source={supportedUnitsForResizing} />
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/ImageResize/ImageSelect.jsx